import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getAllMstRelationshipSlice = createSlice({
    name: "getAllMstRelationship",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAllMstRelationshipSlice_actions = getAllMstRelationshipSlice.actions;
export var fetchData = _getAllMstRelationshipSlice_actions.fetchData, fetchDataSuccess = _getAllMstRelationshipSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllMstRelationshipSlice_actions.fetchDataFailure, resetState = _getAllMstRelationshipSlice_actions.resetState;
export default getAllMstRelationshipSlice.reducer;
